import axios from 'axios';

const list = (params) => axios.get('/segmentos', {
  params,
});

export default {
  list,
};
